import { Component, Input } from '@angular/core';

@Component({
  selector: 'progress-spinner',
  templateUrl: './progress.spinner.component.html',
  styleUrls: ['./progress.spinner.style.scss']
})
export class ProgressSpinnerComponent {
  @Input() height = '100%';
}
